import CustomButton from "../CustomButton";
import CustomFilters from "../CustomFilters";
import "./style.css";

const CustomTable = (props) => {
  return (
    <>
      <CustomFilters
        isFilterOpen={props?.isFilterOpen}

        filterSort={props?.filterSort}
        filterSortValue={props?.filterSortValue}
        setFilterSortValue={props?.setFilterSortValue}
        filterSortValues={props?.filterSortValues}

        filterSearch={props?.filterSearch}
        filterSearchValue={props?.filterSearchValue}
        setFilterSearchValue={props?.setFilterSearchValue}

        dateFilter={props?.dateFilter}
        filterFrom={props?.filterFrom}
        setFilterFrom={props?.setFilterFrom}
        filterTo={props?.filterTo}
        setFilterTo={props?.setFilterTo}

        perPage={props?.perPage}
        perPageValues={props?.perPageValues}
        itemsPerPage={props?.itemsPerPage}
        setItemsPerPage={props?.setItemsPerPage}
      />
      {
        props?.buttonLabel && props?.onClickButton &&
        <div className="row mb-3 justify-content-end">
          <div className="col-12 d-flex justify-content-end">
            <CustomButton text={props?.buttonLabel || ""} onClick={props?.onClickButton} variant="primaryButton" />
          </div>
        </div>
      }
      <div className="customTable">
        <div className="customTableChild">
          <table>
            <thead>
              <tr>
                {/* {
                  !props?.nocheckbox &&
                  <th><input type="checkbox" checked={props?.isAllSelected} onClick={props?.onSelectAll} /></th>
                } */}
                {props?.headers.map((header) => (
                  <th key={header.key}>
                    {header.title}
                  </th>
                ))}
              </tr>
            </thead>
            {props?.length > 0 && props?.children}
          </table>
        </div>
        {
          props?.page && props?.rowsPerPage && props?.length > 0 &&
          <div className="pagination-container">
            <CustomButton text={"Prev"} onClick={props?.onPrevious} />
            <p className="m-0">Showing {((props?.page - 1) * props?.rowsPerPage) + 1} - {((props?.rowsPerPage * (props?.page - 1)) + props?.length)} out of {props?.total || "0"}</p>
            <CustomButton text={"Next"} onClick={props?.onNext} />
          </div>
        }
        {
          props?.length <= 0 &&
          <div className="empty">
            <div className="emptyPanel">
              <p className="emptyEyebrow">Nothing to review</p>
              <h3>No data found</h3>
              <p className="emptyDescription">Try adjusting your filters or check back once new activity comes in.</p>
            </div>
          </div>
        }
      </div>
    </>
  );
};

export default CustomTable;
